import { motion, useReducedMotion } from "framer-motion";
import { t, useLanguage } from "@/i18n/LanguageContext";
import "@/components/design-philosophy.css";

const TECHNICAL_BOARD = "/brand/gfc-tavola-tecnica-originale.jpeg";

export const DesignPhilosophySection = () => {
  useLanguage();
  const reducedMotion = useReducedMotion();
  return (
    <section data-testid="design-philosophy-section" aria-labelledby="design-philosophy-title" className="gfc-design-philosophy py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div data-testid="design-philosophy-introduction" className="grid items-start gap-7 lg:grid-cols-2 lg:gap-16">
          <div className="min-w-0">
            <h2 id="design-philosophy-title" data-testid="design-philosophy-title" className="font-display text-base font-bold leading-relaxed md:text-lg">
              {t("Ogni dettaglio ha una ragione. Ogni progetto ha un metodo.")}
            </h2>
            <p data-testid="design-philosophy-keywords" className="gfc-philosophy-keywords mt-5 border-l-2 pl-4 font-mono text-xs leading-6">
              {t("Progettazione · Precisione · Realizzazione")}
            </p>
          </div>
          <p data-testid="design-philosophy-body" className="min-w-0 text-sm leading-7 text-slate-600 md:text-base">
            {t("In GFC, precisione e visione progettuale sono parte di un unico percorso. Anche il nostro logo racconta questa filosofia: geometrie, proporzioni e dettagli si combinano in un sistema coerente, espressione della cura che mettiamo nel nostro lavoro.")}
          </p>
        </div>
        <motion.figure
          data-testid="design-philosophy-board"
          className="gfc-philosophy-desk mt-10 sm:mt-12"
          initial={reducedMotion ? false : { opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.12 }}
          transition={{ duration: reducedMotion ? 0 : 0.55, ease: "easeOut" }}>
          <img
            data-testid="design-philosophy-desk-background"
            src="/brand/gfc-engineering-desk.webp"
            alt=""
            aria-hidden="true"
            width="1264"
            height="848"
            loading="lazy"
            decoding="async"
            className="gfc-philosophy-desk-background" />
          <a
            data-testid="design-philosophy-original-link"
            href={TECHNICAL_BOARD}
            target="_blank"
            rel="noopener noreferrer"
            title={t("Apri la tavola tecnica originale")}
            aria-label={t("Apri la tavola tecnica originale")}
            className="gfc-philosophy-board-link block cursor-zoom-in">
            <img
              data-testid="design-philosophy-image"
              src={TECHNICAL_BOARD}
              alt={t("Tavola tecnica originale del logo GFC con geometrie, proporzioni e colori istituzionali.")}
              width="1536"
              height="1024"
              loading="lazy"
              decoding="async"
              className="gfc-philosophy-board-image block h-auto w-full object-contain" />
          </a>
        </motion.figure>
      </div>
    </section>
  );
};